import React from 'react';
import PropTypes from 'prop-types';

const Card = ({ 
  children, 
  className = '', 
  onClick = null,
  as: Component = 'div',
  ...props 
}) => {
  const isInteractive = !!onClick;
  
  // Custom keyboard handler for interactive cards (supporting Space and Enter)
  const handleKeyDown = (e) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick(e);
    }
  };

  const interactiveStyles = isInteractive
    ? 'cursor-pointer hover:border-cyan-300 dark:hover:border-cyan-800 hover:shadow-lg dark:hover:shadow-cyan-950/20 active:scale-[0.99] transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-sky-400 dark:focus:ring-offset-slate-900'
    : '';

  const hasPadding = /\bp[xytrbl]?-/.test(className);
  const paddingClass = hasPadding ? '' : 'p-6';

  return (
    <Component
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={isInteractive ? 0 : undefined}
      role={isInteractive ? 'button' : undefined}
      className={`bg-white dark:bg-slate-800 rounded-[2rem] border border-slate-100/80 dark:border-slate-700/50 shadow-sm shadow-slate-100/50 dark:shadow-none ${paddingClass} ${interactiveStyles} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  as: PropTypes.elementType
};

export default Card;
